import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { JwtHelperService } from '@auth0/angular-jwt';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    private jwtHelper: JwtHelperService = new JwtHelperService();

    constructor(private router: Router,
        private authService: AuthService) { }

    canActivate(next: ActivatedRouteSnapshot) {
        if (this.checkToken())
            return true;
        else {
            this.router.navigate(['/login']);
            return false;
        }
    }

    checkToken() {
        var userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        var token = userInfo.token;

        if (!token)
            return false;
        else {
            try {
                var exp = this.jwtHelper.getTokenExpirationDate(token);
            } catch(error) {
                console.error('Invalid token', error);
                return false;
            }
            return exp > new Date();
        }
    }
}
